import { PositionName } from "./name/position-name";
import { PositionJob } from "./job/position-job";
import { PositionIsLeadershipPosition } from "./is-leadership-position/position-is-leadership-position";
import { PositionStaff } from "./staff/position-staff";

/**
 * Поля должности, каждое своим компонентом: показ поля решается один раз здесь, а не
 * на каждой странице заново. Все подкомпоненты принимают сущность целиком —
 * `<Position.Job data={position} />`, — поэтому вызывающему не нужно знать, из какого
 * вложенного поля собирается значение.
 */
export const Position = {
  Name: PositionName,
  Job: PositionJob,
  IsLeadershipPosition: PositionIsLeadershipPosition,
  Staff: PositionStaff,
};
